import React, { useEffect, useRef, useState } from 'react';
import { makeStyles, Typography, TextField } from '@material-ui/core';
import TalentListEmpty from './talentListEmpty';
import SrIconButton from 'core/srIconButton/srIconButton';
import {
  // AccountBoxOutlined,
  FlipToFront,
  GetApp,
  Search,
} from '@material-ui/icons';
import clsx from 'clsx';
import TalentListRow from './talentListRow';
import XLSX from 'xlsx';
// import { SrModal } from 'core/srModal/srModal';
// import Resume from './resume';

const useStyles = makeStyles(() => ({
  container: {
    marginTop: 24,
  },
  contentContainer: {
    paddingLeft: 16,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    height: 48,
    alignItems: 'center',
    borderBottom: '1px solid rgba(0,0,0,0.1)',
    padding: '0 15px',
  },
  title: {
    fontSize: '14px',
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.6)',
  },
  listHeader: {
    display: 'flex',
    height: 58,
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  listHeaderText: {
    fontSize: '14px',
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    flex: '0 0 20%',
    justifyContent: 'center',
  },
  fileNameText: {
    justifyContent: 'flex-start',
    flex: '0 0 40%',
  },
  list: {
    overflow: 'auto',
    height: 'calc(100vh - 350px)',
  },
  searchInput: {
    margin: 0,
    transition: 'all 0.25s linear',
    width: 0,
    marginLeft: 16,
  },
  hiddenIcon: {
    opacity: 0,
    cursor: 'default',
  },
}));

const TalentList = ({ list = [] }) => {
  const classes = useStyles();
  const [showSearch, setShowSearch] = useState(false);
  const [filteredList, setFilteredList] = useState(list);
  const listRef = useRef(null);
  const searchRef = useRef(null);
  // const [selectedDocId, setSelectedDocId] = useState('');

  useEffect(() => {
    if (listRef && listRef.current) {
      listRef.current.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [list]);

  useEffect(() => {
    setFilteredList(list);
  }, [list]);

  if (!list.length) {
    return <TalentListEmpty />;
  }

  const onClickCopy = () => {
    const headers = 'File name\tMatching Score\n';
    const talentListString = list
      .map(({ profileName, score }) => `${profileName}\t${score}`)
      .join('\n');

    navigator.clipboard.writeText(`${headers}${talentListString}`);
  };

  const handleSearch = (e) => {
    const { value } = e.target;

    if (!value) {
      setFilteredList(list);
    }

    setFilteredList(
      list.filter(({ profileName }) =>
        profileName.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const onClickDownload = () => {
    const excelList = list.map(({ profileName, score }) => ({
      'File name': profileName,
      'Matching Score': score,
    }));
    const ws = XLSX.utils.json_to_sheet(excelList);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'talent');
    XLSX.writeFile(wb, 'talent.xlsx', { type: 'xlsx' });
  };

  const onClickResume = (docId) => () => {
    // setSelectedDocId(docId);
  };

  const toggleSearch = (show = false) => () => {
    if (show === true) {
      setShowSearch(true);
      return false;
    }

    if (filteredList.length === list.length) {
      setShowSearch(false);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.contentContainer}>
        <div className={classes.header}>
          <Typography classes={{ root: classes.title }}>
            Match Results
          </Typography>
          <div>
            <SrIconButton
              Icon={GetApp}
              tooltip="Download as Excel"
              onClick={onClickDownload}
            />
            <SrIconButton
              Icon={FlipToFront}
              tooltip="Copy List"
              onClick={onClickCopy}
            />
            {!showSearch && (
              <SrIconButton
                Icon={Search}
                tooltip="Search"
                onClick={toggleSearch(true)}
              />
            )}

            <TextField
              placeholder="search"
              size="small"
              margin="dense"
              classes={{ root: classes.searchInput }}
              style={{ width: showSearch ? '200px' : 0 }}
              onChange={handleSearch}
              onBlur={toggleSearch(false)}
              ref={searchRef}
            />
          </div>
        </div>
        <div className={classes.listHeader}>
          <Typography classes={{ root: classes.listHeaderText }}>
            Rank
          </Typography>
          <Typography
            classes={{
              root: clsx(classes.listHeaderText, classes.fileNameText),
            }}
          >
            File name
          </Typography>
          <Typography classes={{ root: classes.listHeaderText }}>
            Matching Score
          </Typography>
          {/* <SrIconButton Icon={AccountBoxOutlined} className={classes.hiddenIcon} /> */}
        </div>
        <div className={classes.list} ref={listRef}>
          {filteredList.map((props, i) => (
            <TalentListRow
              key={props.docId}
              rank={i + 1}
              {...props}
              onClickResume={onClickResume(props.docId)}
            />
          ))}
        </div>
      </div>
      {/* <SrModal isOpen={selectedDocId} onClose={() => setSelectedDocId('')}>
        <Resume selectedDocId={selectedDocId} />
      </SrModal> */}
    </div>
  );
};

export default TalentList;
